
interface GameDisplayProps {
  x: number;
  y: number;
  answer: number;
  showAnswer: boolean;
  isBlocked?: boolean;
}

const funnyMessages = [
  "Whoa there, speed racer! 🏎️ Take a tiny breather!",
  "Even calculators need a coffee break ☕",
  "Your enthusiasm is amazing, but let's pace ourselves! 🐢",
  "Doing math at light speed? Einstein would be proud! 🧮",
  "Time for a quick math meditation 🧘‍♂️",
  "Your brain deserves a tiny vacation! 🏖️",
  "Let's solve these at a cozy pace 🏡",
  "Taking it slow makes you a math pro! 🌟"
];

export const GameDisplay: React.FC<GameDisplayProps> = ({ 
  x, 
  y, 
  answer, 
  showAnswer,
  isBlocked 
}) => {
  const randomMessage = () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="text-center mb-8">
      <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-400 dark:to-purple-400 bg-clip-text text-transparent">
        {x} × {y} = {showAnswer ? answer : '?'}
      </h2>
      <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
        {isBlocked ? (
          <span className="text-amber-600 dark:text-amber-400">{randomMessage()}</span>
        ) : (
          showAnswer ? 'Press → or Space for next question' : 'Press → or Space to see answer'
        )}
      </p>
    </div>
  );
};